import ShopPaymentResourceModel from '../../generated/types/model/resource/ShopPaymentResourceModel';

export default class ShopPaymentResourceViewModel extends ShopPaymentResourceModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
